import React from 'react';
import { X, Search, Grid, List, Check } from 'lucide-react';

const GalleryModal = ({
  showGalary,
  handleCloseGalary,
  isMobile,
  selectedImages,
  handleCheckboxChange,
  GalleryData,
  searchQuery,
  handleSearchChange,
  selectedCategory,
  handleCategoryChange,
  viewMode,
  setViewMode,
  handleUpload,
}) => {
  if (!showGalary) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '1200px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        {/* Header */}
        <div style={{
          padding: isMobile ? '12px' : '24px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#111827',
              margin: 0
            }}>
              Image Gallery
            </h2>
            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              margin: '4px 0 0 0'
            }}>
              {selectedImages.length} image{selectedImages.length !== 1 ? 's' : ''} selected
            </p>
          </div>
          <button
            onClick={handleCloseGalary}
            style={{
              padding: '8px',
              border: 'none',
              borderRadius: '8px',
              backgroundColor: '#f3f4f6',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e5e7eb'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
          >
            <X size={20} color="#374151" />
          </button>
        </div>

        {/* Filters */}
        <div style={{
          padding: isMobile ? '12px' : '20px 24px',
          borderBottom: '1px solid #e5e7eb',
          backgroundColor: '#f9fafb'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: isMobile ? '8px' : '12px',
            alignItems: 'end'
          }}>
            {/* Search */}
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '8px'
              }}>
                Search Images
              </label>
              <div style={{ position: 'relative' }}>
                <Search
                  size={18}
                  color="#9ca3af"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}
                />
                <input
                  type="text"
                  placeholder="Search by title..."
                  value={searchQuery || ''}
                  onChange={handleSearchChange}
                  style={{
                    width: '100%',
                    padding: '10px 12px 10px 40px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'all 0.2s'
                  }}
                  onFocus={e => e.target.style.borderColor = '#3b82f6'}
                  onBlur={e => e.target.style.borderColor = '#d1d5db'}
                />
              </div>
            </div>

            {/* Category */}
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '8px'
              }}>
                Category
              </label>
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  cursor: 'pointer',
                  backgroundColor: 'white',
                  transition: 'all 0.2s'
                }}
                onFocus={e => e.target.style.borderColor = '#3b82f6'}
                onBlur={e => e.target.style.borderColor = '#d1d5db'}
              >
                <option value="">All Categories</option>
                {[...new Set(GalleryData.map((item) => item.category))].map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            {/* View Toggle */}
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '8px'
              }}>
                View
              </label>
              <div style={{
                display: 'flex',
                gap: '8px',
                backgroundColor: 'white',
                padding: '4px',
                borderRadius: '8px',
                border: '1px solid #d1d5db'
              }}>
                <button
                  onClick={() => setViewMode('grid')}
                  style={{
                    flex: 1,
                    padding: '8px',
                    border: 'none',
                    borderRadius: '6px',
                    backgroundColor: viewMode === 'grid' ? '#3b82f6' : 'transparent',
                    color: viewMode === 'grid' ? 'white' : '#6b7280',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s'
                  }}
                >
                  <Grid size={16} />
                  Grid
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  style={{
                    flex: 1,
                    padding: '8px',
                    border: 'none',
                    borderRadius: '6px',
                    backgroundColor: viewMode === 'list' ? '#3b82f6' : 'transparent',
                    color: viewMode === 'list' ? 'white' : '#6b7280',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s'
                  }}
                >
                  <List size={16} />
                  List
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery Content */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: isMobile ? '12px' : '24px',
        }}>
          {GalleryData.filter((option) =>
            option.title.toLowerCase().includes(searchQuery ? searchQuery.toLowerCase() : "") &&
            (selectedCategory === "" || option.category === selectedCategory)
          ).length === 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              color: '#9ca3af'
            }}>
              <Search size={48} style={{ marginBottom: '16px' }} />
              <p style={{ fontSize: '18px', fontWeight: '500' }}>No images found</p>
              <p style={{ fontSize: '14px' }}>Try adjusting your search or filters</p>
            </div>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: viewMode === 'grid' && isMobile
                ? 'repeat(auto-fill, minmax(140px, 1fr))' : viewMode === 'grid' && !isMobile
                  ? 'repeat(auto-fill, minmax(180px, 1fr))'
                  : '1fr',
              gap: isMobile ? '8px' : '12px',
            }}>
              {GalleryData.filter((option) =>
                option.title.toLowerCase().includes(searchQuery ? searchQuery.toLowerCase() : "") &&
                (selectedCategory === "" || option.category === selectedCategory)
              ).map((option, index) => {
                const isSelected = selectedImages.includes(option.url);
                return (
                  <div
                    key={index}
                    onClick={() => handleCheckboxChange(option.url)}
                    style={{
                      position: 'relative',
                      cursor: 'pointer',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      border: isSelected ? '2px solid #3b82f6' : '2px solid #e5e7eb',
                      transition: 'all 0.2s',
                      backgroundColor: 'white',
                      display: viewMode === 'list' ? 'flex' : 'block',
                      gap: viewMode === 'list' ? '16px' : '0'
                    }}
                    onMouseEnter={e => {
                      if (!isSelected) e.currentTarget.style.borderColor = '#d1d5db';
                    }}
                    onMouseLeave={e => {
                      if (!isSelected) e.currentTarget.style.borderColor = '#e5e7eb';
                    }}
                  >
                    {/* Image */}
                    <div style={{
                      position: viewMode === "list" ? "" : 'relative',
                      aspectRatio: viewMode === 'grid' ? '4/3' : 'auto',
                      width: viewMode === 'list' ? '90px' : '100%',
                      flexShrink: 0
                    }}>
                      <img
                        src={`${process.env.REACT_APP_API_KEY}${option.thumbnailUrl}`}
                        alt={option.title}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                        onError={(e) => {
                          e.target.src = `${process.env.REACT_APP_API_KEY}${option.url}`;
                        }}
                        onContextMenu={(e) => e.preventDefault()}
                      />

                      {/* Selection Indicator */}
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        left: viewMode === "list" ? "" : '8px',
                        right: viewMode === "list" ? "8px" : '',
                        width: '25px',
                        height: '25px',
                        borderRadius: '50%',
                        backgroundColor: isSelected ? '#3b82f6' : 'rgba(255, 255, 255, 0.9)',
                        border: isSelected ? 'none' : '2px solid #d1d5db',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                      }}>
                        {isSelected && <Check size={16} color="white" strokeWidth={3} />}
                      </div>

                      {/* Selected Overlay */}
                      {isSelected && (
                        <div style={{
                          position: 'absolute',
                          inset: 0,
                          backgroundColor: 'rgba(59, 130, 246, 0.1)',
                          pointerEvents: 'none'
                        }} />
                      )}
                    </div>

                    {/* Info */}
                    <div style={{
                      padding: viewMode === 'grid' ? '12px' : '16px',
                      flex: viewMode === 'list' ? 1 : 'none'
                    }}>
                      <h3 style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#111827',
                        margin: '0 0 4px 0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {option.title}
                      </h3>
                      <span style={{
                        display: 'inline-block',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#6b7280',
                        backgroundColor: '#f3f4f6',
                        padding: '4px 8px',
                        borderRadius: '6px'
                      }}>
                        {option.category}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: isMobile ? '8px' : '12px',
          backgroundColor: '#f9fafb'
        }}>
          <div style={{
            fontSize: '14px',
            color: '#6b7280'
          }}>
            {GalleryData.filter((option) =>
              option.title.toLowerCase().includes(searchQuery ? searchQuery.toLowerCase() : "") &&
              (selectedCategory === "" || option.category === selectedCategory)
            ).length} image{GalleryData.filter((option) =>
              option.title.toLowerCase().includes(searchQuery ? searchQuery.toLowerCase() : "") &&
              (selectedCategory === "" || option.category === selectedCategory)
            ).length !== 1 ? 's' : ''} available
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={handleCloseGalary}
              style={{
                padding: '10px 20px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                backgroundColor: 'white',
                color: '#374151',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
            >
              Cancel
            </button>
            <button
              onClick={handleUpload}
              disabled={selectedImages.length === 0}
              style={{
                padding: '10px 24px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: selectedImages.length > 0 ? '#3b82f6' : '#e5e7eb',
                color: selectedImages.length > 0 ? 'white' : '#9ca3af',
                fontSize: '14px',
                fontWeight: '500',
                cursor: selectedImages.length > 0 ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => {
                if (selectedImages.length > 0) {
                  e.currentTarget.style.backgroundColor = '#2563eb';
                }
              }}
              onMouseLeave={e => {
                if (selectedImages.length > 0) {
                  e.currentTarget.style.backgroundColor = '#3b82f6';
                }
              }}
            >
              Upload {selectedImages.length > 0 && `(${selectedImages.length})`}
            </button>
          </div>
        </div>
      </div>

      <style>{`
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  
  /* Custom scrollbar */
  div::-webkit-scrollbar {
    width: 8px;
  }
  
  div::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }
  
  div::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }
  
  div::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
`}</style>
    </div>
  );
};

export default GalleryModal;
